import { History } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export const Timeline = () => {
  const { d, ui } = useLang();
  return (
    <section id="timeline" data-testid="timeline-section" className="scroll-mt-24 border-b border-line bg-surface/50 py-20">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 flex items-start gap-4">
          <div className="rounded-full bg-aegean p-3 text-paper">
            <History className="h-5 w-5" />
          </div>
          <div>
            <p className="eyebrow">{ui.timelineEyebrow}</p>
            <h2 className="mt-2 font-serif text-3xl md:text-4xl font-semibold tracking-tight text-ink">
              {ui.timelineTitle}
            </h2>
          </div>
        </div>
        <ol className="relative ml-3 border-l border-aegean/30 pl-8 md:ml-6">
          {d.TIMELINE.map((t, i) => (
            <li key={i} className="relative pb-10 last:pb-0" data-testid={`timeline-item-${i}`}>
              <span className="absolute -left-[41px] top-1 h-4 w-4 rounded-full border-2 border-aegean bg-paper md:-left-[41px]" />
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-terra">{t.year}</p>
              <h3 className="mt-1 font-serif text-xl font-semibold text-ink">{t.who}</h3>
              <p className="mt-1 max-w-2xl text-sm md:text-base leading-relaxed text-muted-foreground">{t.what}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
